import { defineMessages } from 'react-intl';

export const productBaseInfoMessages = defineMessages({
  tryItOnButton: {
    id: 'pd.tryItOnButton',
    defaultMessage: 'Zkusit na sobě',
  },
  similarProductsButton: {
    id: 'pd.similarProductsButton',
    defaultMessage: 'Podobné produkty',
  },
});
